<div [class]="containerClasses()" [class.om-badge--glass]="isGlass()">
  @if (showDot()) {
  <span [class]="dotClasses()"></span>
  }
  <span [class]="labelClasses()">{{ label() }}</span>
</div>
